<p-toast></p-toast>
<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>

<div class="mx-auto p-8 bg-white rounded-lg shadow-sm flex flex-col space-y-4">
  <!-- Parte superior -->
  <div class="flex-1 p-4 bg-white rounded-lg shadow-sm">
    <h1 class="text-xl font-semibold">Vendas</h1>

    <div class="w-full space-y-4">
      <p-table [value]="vendas" class="w-full mt-6">
        <ng-template pTemplate="header">
          <tr>
            <th class="p-2 border-b text-left">Id</th>
            <th class="p-2 border-b text-left">Cliente</th>
            <th class="p-2 border-b text-left">VendaSituacao</th>
            <th class="p-2 border-b text-left">Usuário</th>
            <th class="p-2 border-b text-left">Vendedor</th>
            <th class="p-2 border-b text-left">Valor Total</th>
            <th class="p-2 border-b text-left">Pagamento</th>
            <th class="p-2 border-b text-left">Observação</th>
            <th class="p-2 border-b text-left">Data Cadastro</th>
            <th class="p-2 border-b text-left">Data Última Modificação</th>
            <th class="p-2 border-b text-center">Ações</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-venda>
          <tr [style.background-color]="'#ebf8ff'" (click)="selecionarVenda(venda)">
            <td class="p-2 border-b w-[5%]">{{ venda.id }}</td>
            <td class="p-2 border-b w-[25%]">{{ venda.cliente.nome }}</td>
            <td class="p-2 border-b w-[10%]">
              <span
                [ngClass]="{
                  'inline-block px-2 py-1 rounded text-sm font-semibold': true,
                  'bg-red-100 text-red-800 border border-red-200': venda.vendaSituacao === 'CANCELADA' || venda.vendaSituacao === 'CANCELADO',
                  'bg-green-100 text-green-800 border border-green-200': venda.vendaSituacao === 'FINALIZADA' || venda.vendaSituacao === 'FECHADA' || venda.vendaSituacao === 'CONCLUIDA',
                  'bg-yellow-100 text-yellow-800 border border-yellow-200': venda.vendaSituacao === 'PENDENTE' || venda.vendaSituacao === 'ABERTA'
                }"
              >
                {{ venda.vendaSituacao || '-' }}
              </span>
            </td>
            <td class="p-2 border-b w-[5%]">{{ venda.usuario.username }}</td>

            <td class="p-2 border-b w-[5%]" style="font-size: 12px;">
               {{ venda.vendedor.nome.split(' ')[0] }}
            </td>

            <td class="p-2 border-b w-[10%]" style="font-size: 12px;">{{ venda.valorTotal | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</td>
            <td class="p-2 border-b w-[5%]">{{ venda.pagamento }}</td>
            <td class="p-2 border-b w-[10%]" style="font-size: 12px;">{{ venda.observacao }}</td>

            <td class="p-2 border-b w-[10%]" style="font-size: 12px;">
              {{ venda.dataCadastro | date : "dd/MM/yyyy HH:mm:ss" : 'America/Sao_Paulo' }}
            </td>
            <td class="p-2 border-b w-[10%]" style="font-size: 12px;">
              {{ venda.dataUltimaModificacao | date : "dd/MM/yyyy HH:mm:ss" : 'America/Sao_Paulo' }}
            </td>
            <td class="p-2 border-b w-[10%]">
              <!-- AÇÕES -->
              <div class="flex items-center space-x-2">
                <button
                  pButton
                  type="button"
                  class="btn btn-md btn-secondary"
                  (click)="$event.stopPropagation(); exportarPdf(venda, 'A4')"
                  title="Exportar A4"
                >
                  <i class="pi pi-file-pdf" style="margin-right:8px"></i>
                  <span>A4</span>
                </button>

                <button
                  pButton
                  type="button"
                  class="btn btn-sm btn-secondary flex items-left"
                  (click)="$event.stopPropagation(); exportarPdf(venda, 'CUPOM')"
                  title="Exportar Cupom"
                >
                  <!--<i class="pi pi-receipt" style="margin-left:8px"></i> -->
                  <span>Cupom</span>
                </button>

                <button
                  *ngIf="venda.vendaSituacao !== 'CANCELADA' && venda.vendaSituacao !== 'PEDIDO'"
                  pButton
                  type="button"
                  class="p-button-danger"
                  (click)="$event.stopPropagation(); cancelarVenda(venda)"
                  title="Cancelar Venda"
                >
                  <i class="pi pi-times"></i>
                </button>
              </div>
            </td>
          </tr>
        </ng-template>

      </p-table>
    </div>
  </div>

  <!-- Exibir os itens da venda selecionada -->
  <div *ngIf="vendaSelecionada">
    <h2>Itens da Venda: {{ vendaSelecionada.id }}</h2>
    <p-table [value]="vendaSelecionada.itens" class="w-full mt-6">
      <ng-template pTemplate="header">
        <tr>
          <th class="p-2 border-b text-left">Id</th>
          <th class="p-2 border-b text-left">Produto</th>
          <th class="p-2 border-b text-left">Quantidade</th>
          <th class="p-2 border-b text-left">Preço</th>
          <th class="p-2 border-b text-left">Desconto</th>
          <th class="p-2 border-b text-left">Acréscimo</th>
          <th class="p-2 border-b text-left">Total</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-itemVenda>
        <tr>
          <td class="p-2 border-b">{{ itemVenda.produto.id }}</td>
          <td class="p-2 border-b">{{ itemVenda.produto.nome }}</td>
          <td class="p-2 border-b">{{ itemVenda.quantidade }}</td>
          <td class="p-2 border-b">{{ itemVenda.produto.preco | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</td>
          <td class="p-2 border-b">{{ itemVenda.valorDesconto | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</td>
          <td class="p-2 border-b">{{ itemVenda.valorAcrescimo | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</td>
          <td class="p-2 border-b">{{ itemVenda.valorTotal | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>



</div>
